// project imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| OVERRIDES - TABS ||============================== //

export default function Tabs(theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 36
        },
        flexContainer: {
          borderBottom: '1px solid',
          borderColor: theme.vars.palette.grey[200],

          ...theme.applyStyles('dark', {
            borderColor: withAlpha(theme.vars.palette.text.primary, 0.2)
          })
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 36,
          padding: '6px 12px',
          textTransform: 'none'
        }
      }
    }
  };
}
